import { authApi } from './authApi';

/**
 * Monta a URL completa a partir de um caminho relativo (para exibir imagens, etc.)
 * Pegando o baseURL atual do authApi. 
 * Se você preferir outra lógica, pode ajustar.
 */
export function getRelativeFileUrl(url?: string): string {
  if (!url) {
    return '';
  }
  // Se já for um link completo
  if (url.startsWith('http://') || url.startsWith('https://')) {
    return url;
  }
  // Caso contrário, concatena com a baseURL do authApi
  return `${authApi.defaults.baseURL}${url}`;
}